import { reducerWithInitialState } from "typescript-fsa-reducers";
import { loadAuditLog, loadHistoryAuditLog, resetAuditLog } from "./actions";
import { AuditLogs, HistoryAuditLogs } from "./types";

export enum AUDIT_LOG_STATES {
  ERROR = "error",
  INITIAL = "initial",
  LOADED = "loaded",
  LOADING = "loading"
}

export interface CompletedAuditLog {
  auditLog: AuditLogs | HistoryAuditLogs;
  status: AUDIT_LOG_STATES.LOADED;
}

export interface ErrorAuditLog {
  status: AUDIT_LOG_STATES.ERROR;
  errorMsg: string;
  auditLog?: AuditLogs;
}

export interface LoadingAuditLog {
  status: AUDIT_LOG_STATES.LOADING;
  auditLog?: AuditLogs;
}

export interface InitialAuditLog {
  status: AUDIT_LOG_STATES.INITIAL;
  auditLog?: AuditLogs;
}

export type AuditLogState =
  | CompletedAuditLog
  | ErrorAuditLog
  | LoadingAuditLog
  | InitialAuditLog;

const auditLogReducer = reducerWithInitialState<Readonly<AuditLogState>>({
  status: AUDIT_LOG_STATES.INITIAL
})
  .case(loadAuditLog.async.done, (state, { result: { auditLog } }) => ({
    status: AUDIT_LOG_STATES.LOADED,
    auditLog
  }))
  .case(loadAuditLog.async.started, (state, _) => {
    return {
      ...state,
      status: AUDIT_LOG_STATES.LOADING
    };
  })
  .case(loadAuditLog.async.failed, (state, { error }) => ({
    ...state,
    status: AUDIT_LOG_STATES.ERROR,
    errorMsg: error.message
  }))
  .case(loadHistoryAuditLog.async.done, (state, { result: { auditLog } }) => ({
    status: AUDIT_LOG_STATES.LOADED,
    auditLog
  }))
  .case(loadHistoryAuditLog.async.started, (state, _) => ({
    ...state,
    status: AUDIT_LOG_STATES.LOADING
  }))
  .case(loadHistoryAuditLog.async.failed, (state, { error }) => ({
    status: AUDIT_LOG_STATES.ERROR,
    errorMsg: error.message
  }))
  .case(resetAuditLog.async.started, (state, _) => ({
    status: AUDIT_LOG_STATES.INITIAL,
    auditLog: undefined
  }));

export default auditLogReducer;



// WEBPACK FOOTER //
// ./src/auditLog/reducer.ts